module.exports = new __parcel__URL__("empty-icon.ef7b6c4a.svg").toString();